import api from '../../../api';

const path = '/parts/all';

export const getPartsAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getPartsAllListRequest = (params) =>
    api.get(`${path}/get`, { params });

export const getPartsNoAccountAllRequest = (id) =>
    api.get(`${path}/list/get/${id}`);
export const getPartsNoAccountAllListRequest = (params) =>
    api.get(`${path}/list/get`, { params });
